var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3191 11.3062C9.01525 11.3062 9.5796 10.7418 9.5796 10.0457C9.5796 9.3495 9.01525 8.78516 8.3191 8.78516C7.62294 8.78516 7.05859 9.3495 7.05859 10.0457C7.05859 10.7418 7.62294 11.3062 8.3191 11.3062Z",
    fill: "#40C706"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4519 8.78516C11.7586 8.78516 11.1914 9.35238 11.1914 10.0457C11.1914 10.7389 11.7586 11.3062 12.4519 11.3062C13.1452 11.3062 13.7124 10.7389 13.7124 10.0457C13.7124 9.35238 13.1452 8.78516 12.4519 8.78516Z",
    fill: "#40C706"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3281 10.0457C15.3281 10.7389 15.8954 11.3062 16.5886 11.3062C17.2819 11.3062 17.8491 10.7389 17.8491 10.0457C17.8491 9.35238 17.2819 8.78516 16.5886 8.78516C15.8954 8.78516 15.3281 9.35238 15.3281 10.0457Z",
    fill: "#40C706"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0124 19.0713L16.9914 17.3696L17.7477 17.3822C15.504 18.4662 13.0082 18.983 10.525 18.9074C8.64687 18.857 6.74351 18.4662 5.02922 17.6469C1.99141 16.2099 -0.378343 13.1973 0.0502288 9.6679C0.365355 6.98303 2.09225 4.75194 4.2351 3.26454C9.51662 -0.516971 19.0838 -0.579996 22.9284 5.25614C23.9998 6.92 24.2771 9.05026 23.6847 10.941C23.3065 12.1889 22.6259 13.2982 21.7813 14.2309C21.5166 14.5208 21.0754 14.5461 20.7855 14.2813C20.4956 14.0292 20.4704 13.5881 20.7225 13.2982C22.9662 10.7771 23.1427 7.28555 20.5712 4.94101C15.8443 0.718323 6.81914 2.04185 3.21409 7.14689C1.32334 9.86958 1.91578 13.0461 4.58804 14.9872C6.30233 16.2477 8.4704 16.8528 10.6006 16.9536C12.8317 17.0671 15.0754 16.6385 17.1301 15.7435C17.3443 15.6553 17.5838 15.6931 17.7729 15.794L21.5796 17.9494C22.2477 18.3402 21.7561 19.3612 21.0124 19.0713Z",
    fill: "#40C706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistance);
export default __webpack_public_path__ + "static/media/assistance.6f409ad7ec31b7a4bd7a465fc8673eb2.svg";
export { ForwardRef as ReactComponent };